<template>
  <a-modal :visible="visible" :title="isEdit ? '编辑商品' : '新增商品'" :width="1000" :footer="null" @cancel="handleCancel" destroyOnClose :maskClosable="false">
    <div class="product-modal-wrapper">
      <a-spin :spinning="pageLoading">
        <div class="product-modal-body">
          <div class="blue-border-box basic-info-section">
            <div class="info-col-left">
              <a-form ref="formRef" :model="formState" layout="horizontal" :label-col="{ style: { width: '50px' } }">
                <a-form-item label="名称" name="name" :rules="[{ required: true, message: '请输入名称' }]">
                  <a-input v-model:value="formState.name" placeholder="请输入商品名称" />
                </a-form-item>
                <a-form-item label="单位" name="unit">
                  <a-input v-model:value="formState.unit" placeholder="个" />
                </a-form-item>
                <a-form-item label="价格" name="price">
                  <a-input-number v-model:value="formState.price" style="width: 100%" :min="0" :precision="2" prefix="￥" />
                </a-form-item>
                <div class="status-row">
                  <span class="label">状态：</span>
                  <span :class="formState.enabled ? 'status-on' : 'status-off'">
                    {{ formState.enabled ? '已上架' : '未上架' }}
                  </span>
                </div>
              </a-form>
            </div>

            <div class="info-col-center">
              <div class="center-upload-wrapper">
                <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" :custom-request="handleThumbnailUpload" :before-upload="beforeUpload">
                  <div v-if="formState.thumbnailUuid" class="upload-preview">
                    <img :src="imageUrl + formState.thumbnailUuid" class="preview-img" alt="img" />
                    <div class="upload-actions">
                      <div @click.stop>
                        <a-popconfirm title="确定删除缩略图吗？" @confirm="removeThumbnail" okText="确定" cancelText="取消">
                          <delete-outlined class="delete-icon-btn" title="删除图片" />
                        </a-popconfirm>
                      </div>
                      <span class="replace-tip">点击替换</span>
                    </div>
                  </div>
                  <div v-else class="upload-trigger-content">
                    <loading-outlined v-if="uploadLoading" />
                    <plus-outlined v-else />
                    <div class="ant-upload-text">缩略图</div>
                  </div>
                </a-upload>
                <div class="upload-tip-text">图片大小 170x170 像素</div>
              </div>
            </div>

            <div class="info-col-right">
              <a-popconfirm v-if="formState.id" :title="`确定要${formState.enabled ? '下架' : '上架'}该商品吗？`" @confirm="handleToggleStatus">
                <a-button block class="action-btn" :type="formState.enabled ? 'danger' : 'primary'">
                  {{ formState.enabled ? '下架' : '上架' }}
                </a-button>
              </a-popconfirm>
              <a-button v-else block disabled class="action-btn">未保存</a-button>

              <a-button type="primary" block class="action-btn save-btn" :loading="submitLoading" @click="handleSaveBasicInfo">
                保 存
              </a-button>
            </div>
          </div>

          <div class="blue-border-box tabs-section">
            <div v-if="!formState.id" class="lock-overlay">
              <span>请先填写并保存上方基本信息以创建商品</span>
            </div>

            <a-tabs v-model:activeKey="activeTab" type="card">

              <a-tab-pane key="category" tab="分类">
                <div class="tab-panel-content category-layout">
                  <div class="cat-col">
                    <h3 class="cat-title">商城产品类别</h3>
                    <a-checkbox-group v-model:value="formState.productCategories" style="width: 100%" @change="handleProductCategoryChange">
                      <a-row>
                        <a-col :span="24" v-for="opt in categoryOptions" :key="opt.id">
                          <a-checkbox :value="opt.value" class="custom-checkbox">{{ opt.value }}</a-checkbox>
                        </a-col>
                      </a-row>
                    </a-checkbox-group>
                  </div>

                  <div class="cat-col">
                    <h3 class="cat-title">促销品类</h3>
                    <a-checkbox-group v-model:value="formState.promotions" style="width: 100%" @change="handlePromotionChange">
                      <a-row>
                        <a-col :span="24" v-for="opt in promotionOptions" :key="opt.id">
                          <a-checkbox :value="opt.value" class="custom-checkbox">{{ opt.value }}</a-checkbox>
                        </a-col>
                        <!-- <a-empty v-if="promotionOptions.length === 0" image="simple" description="暂无促销分类" style="margin: 20px auto" /> -->
                      </a-row>
                    </a-checkbox-group>
                  </div>
                </div>
              </a-tab-pane>

              <a-tab-pane key="specs" tab="规格">
                <div class="tab-panel-content">
                  <a-table :dataSource="formState.specs" :columns="specColumns" :pagination="false" rowKey="key" size="small">
                    <template #specName="{ text, record }">
                      <a-input v-if="record.isEditing" v-model:value="record.specName" placeholder="规格名" />
                      <span v-else>{{ text }}</span>
                    </template>
                    <template #price="{ text, record }">
                      <a-input-number v-if="record.isEditing" v-model:value="record.price" :min="0" :precision="2" style="width: 100px" />
                      <span v-else>￥{{ text }}</span>
                    </template>
                    <template #action="{ record, index }">
                      <div class="action-row">
                        <template v-if="record.isEditing">
                          <a-button type="link" size="small" @click="saveRow('spec', index)">保存</a-button>
                          <a-button type="link" size="small" @click="cancelRow('spec', index)">取消</a-button>
                        </template>
                        <template v-else>
                          <a-button type="link" size="small" :disabled="hasEditingRow" @click="editRow('spec', index)">编辑</a-button>
                          <a-popconfirm title="确定删除吗?" @confirm="deleteRow('spec', index)">
                            <a-button type="link" danger size="small" :disabled="hasEditingRow">删除</a-button>
                          </a-popconfirm>
                        </template>
                      </div>
                    </template>
                  </a-table>
                  <a-button type="dashed" block @click="addRow('spec')" style="margin-top: 10px" :disabled="hasEditingRow">
                    <plus-outlined /> 添加规格
                  </a-button>
                </div>
              </a-tab-pane>

              <a-tab-pane key="images" tab="图片">
                <div class="tab-panel-content">
                  <div class="grid-image-container">
                    <div v-for="(item, index) in fileList" :key="item.uid" class="grid-image-item">
                      <img :src="item.url" />
                      <div class="image-actions">
                        <eye-outlined @click="handlePreview(item)" title="预览" class="action-icon" />
                        <arrow-left-outlined v-if="index > 0" @click="moveSlideImage(index, -1)" title="前移" class="action-icon" />
                        <arrow-right-outlined v-if="index < fileList.length - 1" @click="moveSlideImage(index, 1)" title="后移" class="action-icon" />

                        <a-popconfirm title="确定删除这张轮播图吗？" @confirm="removeSlideImage(index)" okText="确定" cancelText="取消">
                          <delete-outlined title="删除" class="action-icon delete-icon" />
                        </a-popconfirm>
                      </div>
                    </div>
                    <div class="grid-image-item upload-grid-btn">
                      <a-upload list-type="picture-card" :show-upload-list="false" :custom-request="handleSlideUploadDirect" :before-upload="beforeUpload" class="full-size-uploader">
                        <div class="upload-trigger-inner">
                          <loading-outlined v-if="sliderLoading" />
                          <plus-outlined v-else />
                          <div class="ant-upload-text">轮播图</div>
                        </div>
                      </a-upload>
                    </div>
                  </div>
                  <div class="tab-hint-text">温馨提示：商品图片最佳尺寸 170 x 170 像素</div>
                </div>
              </a-tab-pane>

              <a-tab-pane key="intro" tab="介绍">
                <div class="tab-panel-content">
                  <div class="grid-image-container">
                    <div v-for="(detail, index) in formState.details" :key="detail.id" class="grid-image-item">
                      <img :src="imageUrl + detail.imgUuid" />
                      <div class="image-actions">
                        <eye-outlined @click="handleDetailPreview(detail.imgUuid)" title="预览" class="action-icon" />
                        <arrow-left-outlined v-if="index > 0" @click="moveDetail(index, -1)" title="前移" class="action-icon" />
                        <arrow-right-outlined v-if="index < formState.details.length - 1" @click="moveDetail(index, 1)" title="后移" class="action-icon" />

                        <a-popconfirm title="确定删除这张介绍图片吗？" @confirm="removeDetail(index)" okText="确定" cancelText="取消">
                          <delete-outlined title="删除" class="action-icon delete-icon" />
                        </a-popconfirm>
                      </div>
                    </div>
                    <div class="grid-image-item upload-grid-btn">
                      <a-upload name="file" list-type="picture-card" :show-upload-list="false" :custom-request="handleDetailUploadDirect" :before-upload="beforeUpload" class="full-size-uploader">
                        <div class="upload-trigger-inner">
                          <loading-outlined v-if="detailLoading" />
                          <plus-outlined v-else />
                          <div class="ant-upload-text">添加切片</div>
                        </div>
                      </a-upload>
                    </div>
                  </div>
                  <div class="tab-hint-text">温馨提示：详情（介绍）图片宽度 375 像素，长度不限</div>
                </div>
              </a-tab-pane>

              <a-tab-pane key="params" tab="参数">
                <div class="tab-panel-content">
                  <a-table :dataSource="formState.params" :columns="paramColumns" :pagination="false" rowKey="key" size="small">
                    <template #label="{ text, record }">
                      <a-input v-if="record.isEditing" v-model:value="record.label" placeholder="参数名" />
                      <span v-else>{{ text }}</span>
                    </template>
                    <template #value="{ text, record }">
                      <a-input v-if="record.isEditing" v-model:value="record.value" placeholder="参数值" />
                      <span v-else>{{ text }}</span>
                    </template>
                    <template #action="{ record, index }">
                      <div class="action-row">
                        <template v-if="record.isEditing">
                          <a-button type="link" size="small" @click="saveRow('param', index)">保存</a-button>
                          <a-button type="link" size="small" @click="cancelRow('param', index)">取消</a-button>
                        </template>
                        <template v-else>
                          <a-button type="link" size="small" :disabled="hasEditingRow" @click="editRow('param', index)">编辑</a-button>
                          <a-popconfirm title="确定删除吗?" @confirm="deleteRow('param', index)">
                            <a-button type="link" danger size="small" :disabled="hasEditingRow">删除</a-button>
                          </a-popconfirm>
                        </template>
                      </div>
                    </template>
                  </a-table>
                  <a-button type="dashed" block @click="addRow('param')" style="margin-top: 10px" :disabled="hasEditingRow">
                    <plus-outlined /> 添加参数
                  </a-button>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>

        </div>
      </a-spin>
    </div>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </a-modal>
</template>

<script>
import { message } from 'ant-design-vue';
import {
  AddProduct, UpdateProduct, GetProductDetail,
  AddSku, UpdateSku, DeleteSku,
  AddProductAttribute, UpdateProductAttribute, DeleteProductAttribute, ReorderProductAttribute, UpdateProductStatus, GetMallSettingList
} from "/src/api/shopping.js";
import { Upload } from "/src/api/upload.js";
import {
  PlusOutlined, LoadingOutlined, EyeOutlined, DeleteOutlined,
  ArrowLeftOutlined, ArrowRightOutlined,
} from '@ant-design/icons-vue';
export default {
  name: "ProductModal",
  components: {
    PlusOutlined, LoadingOutlined, EyeOutlined, DeleteOutlined,
    ArrowLeftOutlined, ArrowRightOutlined
  },
  props: {
    visible: { type: Boolean, default: false },
    record: { type: Object, default: () => ({}) }
  },
  emits: ['update:visible', 'ok'],

  data() {
    return {
      activeTab: 'category',
      uploadLoading: false,
      sliderLoading: false,
      detailLoading: false,
      submitLoading: false,
      pageLoading: false,
      imageUrl: '/api/file/img/',
      fileList: [],
      previewVisible: false,
      previewImage: '',
      categoryOptions: [],
      promotionOptions: [],
      formState: {
        id: undefined, name: undefined, unit: undefined, price: undefined, type: undefined, thumbnailUuid: undefined,
        specs: [],
        details: [],
        promotions: [],
        productCategories: [],
        params: [],
        enabled: false,
      },
      promotionMap: {},
      categoryMap: {},

      specColumns: [
        { title: '规格名称', dataIndex: 'specName', slots: { customRender: 'specName' } },
        { title: '价格', dataIndex: 'price', slots: { customRender: 'price' }, width: 120 },
        { title: '操作', key: 'action', slots: { customRender: 'action' }, width: 150, align: 'center' }
      ],
      paramColumns: [
        { title: '参数名', dataIndex: 'label', slots: { customRender: 'label' }, width: 150 },
        { title: '参数值', dataIndex: 'value', slots: { customRender: 'value' } },
        { title: '操作', key: 'action', slots: { customRender: 'action' }, width: 150, align: 'center' }
      ],
    };
  },

  computed: {
    isEdit() { return !!this.record?.id; },
    hasEditingRow() {
      const specEditing = this.formState.specs.some(item => item.isEditing);
      const paramEditing = this.formState.params.some(item => item.isEditing);
      return specEditing || paramEditing;
    }
  },

  watch: {
    visible(val) {
      if (val) this.initData();
    }
  },

  methods: {
    async initData() {
      this.resetForm();
      this.activeTab = 'category';
      this.fetchCategoryOptions();

      if (this.isEdit) {
        this.pageLoading = true;
        try {
          const res = await GetProductDetail({ uuid: this.record.uuid });
          if (res && res.data) {
            this.mapDataToForm(res.data);
          }
        } catch (error) {
          console.error(error);
          message.error('获取商品详情失败');
        } finally {
          this.pageLoading = false;
        }
      }
    },
    async fetchCategoryOptions() {
      try {
        const clubId = this.$store.state.club?.id;
        const [catRes, promoRes] = await Promise.all([
          GetMallSettingList({ category: '商城产品类别', excludeEmpty: true, clubId }),
          GetMallSettingList({ category: '促销品类', excludeEmpty: true, clubId })
        ]);
        if (catRes.data) this.categoryOptions = catRes.data;
        if (promoRes.data) this.promotionOptions = promoRes.data;
      } catch (e) {
        console.error('获取字典列表失败', e);
      }
    },
    mapDataToForm(data) {
      this.formState.id = data.id;
      this.formState.name = data.name;
      this.formState.unit = data.packageUnit;
      this.formState.price = data.price;
      this.formState.type = data.category;
      this.formState.thumbnailUuid = data.thumbnailUuid;
      this.formState.enabled = data.enabled;

      this.formState.specs = (data.skus || []).map((item, index) => ({
        id: item.id,
        specName: item.name,
        price: item.price,
        code: item.code,
        isEditing: false,
        key: item.id || index
      }));

      const attrs = data.attributeMap || {};
      const params = attrs['产品参数'] || [];
      this.formState.params = params.map((item, index) => ({
        id: item.id,
        label: item.name,
        value: item.value,
        isEditing: false,
        key: item.id || index
      }));

      const promotions = attrs['促销品类'] || [];
      this.formState.promotions = promotions.map(a => a.value);
      this.promotionMap = {};
      promotions.forEach(p => { this.promotionMap[p.value] = p.id; });

      const categories = attrs['商城产品类别'] || [];
      this.formState.productCategories = categories.map(a => a.value);
      this.categoryMap = {};
      categories.forEach(p => { this.categoryMap[p.value] = p.id; });

      const sliders = (attrs['商品图片'] || []).sort((a, b) => (a.sort || a.sequence || 0) - (b.sort || b.sequence || 0));
      this.fileList = sliders.map((item, index) => ({
        uid: item.id,
        name: 'image.png',
        status: 'done',
        url: this.imageUrl + item.value,
        response: item.value,
        id: item.id,
        sort: item.sort || item.sequence,
      }));

      const details = (attrs['商品介绍'] || []).sort((a, b) => (a.sort || a.sequence || 0) - (b.sort || b.sequence || 0));
      this.formState.details = details.map((item, index) => ({
        id: item.id,
        imgUuid: item.value,
        sort: item.sort || item.sequence
      }));
    },
    resetForm() {
      this.formState = {
        id: undefined, name: undefined, unit: undefined, price: undefined, type: undefined, thumbnailUuid: undefined,
        specs: [], details: [], promotions: [], productCategories: [], params: [], enabled: false
      };
      this.fileList = [];
      this.promotionMap = {};
      this.categoryMap = {};
    },
    async handleSaveBasicInfo() {
      if (!this.formState.name) return message.warning('请输入商品名称');
      this.submitLoading = true;
      try {
        const baseData = {
          id: this.formState.id,
          name: this.formState.name,
          packageUnit: this.formState.unit,
          price: this.formState.price,
          // category: this.formState.type,
          thumbnailUuid: this.formState.thumbnailUuid
        };

        if (this.formState.id) {
          await UpdateProduct(baseData);
          message.success('基本信息已更新');
          // this.$emit('ok');
        } else {
          const res = await AddProduct(baseData);
          this.formState.id = res.data?.id || res.data;
          message.success('商品已创建，请继续添加规格和图片');
          // this.$emit('ok');
        }
      } catch (error) {
        message.error('保存失败: ' + (error.message || '系统错误'));
      } finally {
        this.submitLoading = false;
      }
    },
    async handleToggleStatus() {
      if (!this.formState.id) return;
      const currentStatus = this.formState.enabled;
      const actionName = currentStatus ? '下架' : '上架';
      const newStatus = !currentStatus;

      try {
        this.submitLoading = true;
        await UpdateProductStatus({ id: this.formState.id, enabled: newStatus });
        this.formState.enabled = newStatus;
        message.success(`商品已${actionName}`);
        this.$emit('ok');
      } catch (error) {
        message.error(`${actionName}失败`);
      } finally {
        this.submitLoading = false;
      }
    },
    addRow(type) {
      const list = type === 'spec' ? this.formState.specs : this.formState.params;
      list.push({
        id: null, isEditing: true, key: Date.now(),
        ...(type === 'spec' ? { specName: '', price: 0 } : { label: '', value: '' })
      });
    },
    editRow(type, index) {
      const list = type === 'spec' ? this.formState.specs : this.formState.params;
      const item = list[index];
      item._original = { ...item };
      item.isEditing = true;
    },
    cancelRow(type, index) {
      const list = type === 'spec' ? this.formState.specs : this.formState.params;
      const item = list[index];
      if (!item.id) {
        list.splice(index, 1);
      } else {
        Object.assign(item, item._original);
        delete item._original;
        item.isEditing = false;
      }
    },
    async saveRow(type, index) {
      const list = type === 'spec' ? this.formState.specs : this.formState.params;
      const item = list[index];

      if (type === 'spec' && !item.specName) return message.warning('请输入规格名称');
      if (type === 'param' && !item.label) return message.warning('请输入参数名');

      try {
        let res;
        if (type === 'spec') {
          const payload = { id: item.id, productId: this.formState.id, name: item.specName, price: item.price };
          res = item.id ? await UpdateSku(payload) : await AddSku(payload);
        } else {
          const payload = { id: item.id, productId: this.formState.id, category: '产品参数', name: item.label, value: item.value };
          res = item.id ? await UpdateProductAttribute(payload) : await AddProductAttribute(payload);
        }
        item.id = res.data?.id || res.data || item.id;
        item.isEditing = false;
        delete item._original;
        message.success('保存成功');
      } catch (e) {
        console.error(e);
        message.error('保存失败');
      }
    },
    async deleteRow(type, index) {
      const list = type === 'spec' ? this.formState.specs : this.formState.params;
      const item = list[index];
      try {
        if (type === 'spec') {
          await DeleteSku({ id: item.id });
        } else {
          await DeleteProductAttribute({ id: item.id });
        }
        list.splice(index, 1);
        message.success('已删除');
      } catch (e) {
        message.error('删除失败');
      }
    },
    handleSlideUploadDirect(options) {
      this.sliderLoading = true;
      this.commonUpload(options, async (uuid) => {
        try {
          const sort = this.fileList.length;
          const res = await AddProductAttribute({
            productId: this.formState.id,
            category: '商品图片',
            value: uuid,
            name: '商品图片',
            sort: sort
          });
          const newId = res.data?.id || res.data;
          this.fileList.push({
            uid: newId, name: 'image.png', status: 'done', url: this.imageUrl + uuid, response: uuid, id: newId, sort: sort
          });
          message.success('商品图片添加成功');
        } catch (e) {
          message.error('关联商品图片失败');
        } finally {
          this.sliderLoading = false;
        }
      });
    },
    async removeSlideImage(index) {
      const item = this.fileList[index];
      if (!item.id) return;
      try {
        await DeleteProductAttribute({ id: item.id });
        this.fileList.splice(index, 1);
        message.success('删除成功');
      } catch (e) {
        message.error('删除失败');
      }
    },
    async moveSlideImage(index, direction) {
      const arr = this.fileList;
      const newIndex = index + direction;
      [arr[index], arr[newIndex]] = [arr[newIndex], arr[index]];
      this.fileList = [...arr];
      const ids = this.fileList.map(f => f.id);
      try {
        await ReorderProductAttribute(ids);
      } catch (e) {
        message.error('排序保存失败');
      }
    },
    handleDetailUploadDirect(options) {
      this.detailLoading = true;
      this.commonUpload(options, async (uuid) => {
        try {
          const sort = this.formState.details.length;
          const res = await AddProductAttribute({
            productId: this.formState.id,
            category: '商品介绍',
            value: uuid,
            name: '商品介绍',
          });
          this.formState.details.push({
            id: res.data?.id || res.data, imgUuid: uuid, sort: sort
          });
          message.success('详情切片添加成功');
        } catch (e) {
          message.error('保存商品介绍失败');
        } finally {
          this.detailLoading = false;
        }
      });
    },
    async removeDetail(index) {
      const item = this.formState.details[index];
      try {
        await DeleteProductAttribute({ id: item.id });
        this.formState.details.splice(index, 1);
        message.success('删除成功');
      } catch (e) {
        message.error('删除失败');
      }
    },
    async moveDetail(index, direction) {
      const arr = this.formState.details;
      const newIndex = index + direction;
      [arr[index], arr[newIndex]] = [arr[newIndex], arr[index]];
      const ids = this.formState.details.map(d => d.id);
      try {
        await ReorderProductAttribute(ids);
      } catch (e) {
        message.error('排序保存失败');
      }
    },
    async handleProductCategoryChange(checkedValues) {
      if (!this.formState.id) {
        message.warning('请先保存商品基本信息');
        this.formState.productCategories = Object.keys(this.categoryMap);
        return;
      }
      const currentSet = new Set(checkedValues);
      for (const key in this.categoryMap) {
        if (!currentSet.has(key)) {
          const idToDelete = this.categoryMap[key];
          try {
            await DeleteProductAttribute({ id: idToDelete });
            delete this.categoryMap[key];
          } catch (e) {
            console.error('删除类别失败', e);
            message.error(`移除 ${key} 失败`);
          }
        }
      }
      for (const val of checkedValues) {
        if (!this.categoryMap[val]) {
          try {
            const res = await AddProductAttribute({
              productId: this.formState.id,
              category: '商城产品类别',
              value: val,
              name: val
            });
            const newId = res.data?.id || res.data;
            this.categoryMap[val] = newId;
          } catch (e) {
            console.error('新增类别失败', e);
            message.error(`添加 ${val} 失败`);
            this.formState.productCategories = this.formState.productCategories.filter(p => p !== val);
          }
        }
      }
    },
    async handlePromotionChange(checkedValues) {
      const currentSet = new Set(checkedValues);
      for (const key in this.promotionMap) {
        if (!currentSet.has(key)) {
          const idToDelete = this.promotionMap[key];
          try {
            await DeleteProductAttribute({ id: idToDelete });
            delete this.promotionMap[key];
          } catch (e) {
            console.error('删除促销失败', e);
          }
        }
      }
      for (const val of checkedValues) {
        if (!this.promotionMap[val]) {
          try {
            const res = await AddProductAttribute({
              productId: this.formState.id,
              category: '促销品类',
              value: val,
              name: val
            });
            const newId = res.data?.id || res.data;
            this.promotionMap[val] = newId;
          } catch (e) {
            console.error('新增促销失败', e);
            message.error('促销状态同步失败');
            this.formState.promotions = this.formState.promotions.filter(p => p !== val);
          }
        }
      }
    },
    async commonUpload({ file, onSuccess, onError }, callback) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('category', 'product');
      formData.append('system', 'true');
      try {
        const res = await Upload(formData);
        if (res.errCode === 0 && res.data) {
          if (callback) callback(res.data);
          onSuccess(res.data);
        } else {
          message.error('上传失败：' + (res.message || '未知错误'));
          onError(new Error('Upload failed'));
        }
      } catch (error) {
        message.error('网络错误，上传失败');
        onError(error);
      }
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) message.error('只能上传 JPG/PNG 文件!');
      return isJpgOrPng;
    },
    handleThumbnailUpload(options) {
      this.uploadLoading = true;
      this.commonUpload(options, (uuid) => {
        this.formState.thumbnailUuid = uuid;
        this.uploadLoading = false;
      });
    },
    removeThumbnail() {
      this.formState.thumbnailUuid = '';
    },
    handleCancel() {
      this.$emit('ok');
      this.$emit('update:visible', false);
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleDetailPreview(uuid) {
      this.previewImage = this.imageUrl + uuid;
      this.previewVisible = true;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
  }
};
</script>

<style scoped>
/* ================= 容器与区块样式 ================= */
.product-modal-wrapper .blue-border-box {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  background: #fff;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  transition: all 0.3s;
}

.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666;
  font-weight: bold;
  cursor: not-allowed;
}

/* ================= 顶部基本信息布局 ================= */
.basic-info-section {
  display: flex;
  align-items: flex-start;
  gap: 30px;
}

.info-col-left {
  flex: 1;
  max-width: 320px;
}

.status-row {
  margin-top: 6px;
  font-size: 14px;
  line-height: 32px;
}

.status-row .label {
  color: #666;
  margin-right: 8px;
  display: inline-block;
  width: 50px;
  text-align: right;
}

.status-on {
  color: #52c41a;
  font-weight: bold;
}

.status-off {
  color: #ff4d4f;
  font-weight: bold;
}

/* --- 中间：缩略图 --- */
.info-col-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 4px;
}

.center-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-tip-text {
  margin-top: 8px;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  text-align: center;
}

.avatar-uploader :deep(.ant-upload) {
  width: 120px;
  height: 120px;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  overflow: hidden;
  transition: border-color 0.3s;
  cursor: pointer;
}

.avatar-uploader :deep(.ant-upload:hover) {
  border-color: #409eff;
}

.upload-trigger-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #666;
}

.upload-trigger-content .anticon {
  font-size: 24px;
  margin-bottom: 8px;
  color: #999;
}

.upload-trigger-content .ant-upload-text {
  font-size: 14px;
  color: #666;
}

.upload-preview {
  width: 100%;
  height: 100%;
  position: relative;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-actions {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s;
  cursor: pointer;
}

.upload-preview:hover .upload-actions {
  opacity: 1;
}

.delete-icon-btn {
  font-size: 18px;
  margin-bottom: 8px;
  color: #fff;
  transition: color 0.3s;
  padding: 4px;
  z-index: 2;
}

.delete-icon-btn:hover {
  color: #ff4d4f;
}

.replace-tip {
  font-size: 12px;
  color: #e6e6e6;
  user-select: none;
}

.info-col-right {
  width: 120px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: flex-start;
  padding-top: 4px;
}

.action-btn {
  height: 32px;
  border-radius: 4px;
}

/* ================= 分类 Tab 样式 ================= */
.category-layout {
  display: flex;
  gap: 40px;
  padding: 10px 20px;
}

.cat-col {
  flex: 1;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 20px;
  background: #fafafa;
}

.cat-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
  color: #333;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
}

.custom-checkbox {
  font-size: 15px;
  margin-bottom: 12px;
  display: block;
  margin-left: 0 !important;
}

/* ================= Grid 布局样式 ================= */
.tab-panel-content {
  padding: 20px;
}

.grid-image-container {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  width: 100%;
}

.grid-image-item {
  width: 100%;
  aspect-ratio: 1 / 1;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff;
  padding: 8px;
  box-sizing: border-box;
}

.grid-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-actions {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s;
}

.grid-image-item:hover .image-actions {
  opacity: 1;
}

.action-icon {
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}

.delete-icon:hover {
  color: #ff4d4f;
}

.upload-grid-btn {
  border-style: dashed;
  background: #fafafa;
  padding: 0;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-grid-btn:hover {
  border-color: #409eff;
}

.full-size-uploader {
  width: 100%;
  height: 100%;
  display: block;
}

.full-size-uploader :deep(.ant-upload-select-picture-card) {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  border: none !important;
  background: transparent !important;
}

.full-size-uploader :deep(.ant-upload) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
}

.action-row {
  display: flex;
  gap: 8px;
  justify-content: center;
}

/* 新增的底部提示样式 */
.tab-hint-text {
  margin-top: 15px;
  font-size: 12px;
  color: #999;
  text-align: left;
}
</style>